import { useTranslate } from '@festina-life/ui/hooks'
import { Icon } from '@festina-life/ui/structure'

export const StandardBranchNameAndCategory = () => {
  const translate = useTranslate()

  return (
    <div className="flex gap-x-2 grow">
      <Icon name="BuildingOffice" size="sm" />
      <div>{translate('branch.default')}</div>
    </div>
  )
}
